// extracted by mini-css-extract-plugin
export default {"root":"OFJ_9YsrmdDIYFXblfna","checkbox":"A0DgkOfv3qP6wr29amXO","label":"qjE0mJegrPmfSfsGyaN5"};